import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getOnlineStoreUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.onlinestore.url');
  }

  return get(cfg, 'common.onlinestore.wl_url');
};

export default getOnlineStoreUrl;
